enum MultiActionDialogKey {
  ADD_CONSTITUENT = 'add-constituent',
  ADD_OPPORTUNITY = 'add-opportunity',
  ADD_TASK = 'add-task',
  ASSIGN = 'assign',
  DELETE_FEED_ITEM_CONFIRMATION = 'delete-confirmaiton',
  DELETE_CONSTITUENT = 'delete-constituent',
  DONATION = 'donation',
  EDIT = 'edit',
  EDIT_TASK = 'edit-task',
  INTERACTION = 'interaction',
  MOVE = 'move',
  REMOVE = 'remove-constituent-card',
}

export default MultiActionDialogKey;
